import React, { useEffect, useState } from "react";

/**
 * Imagem com lista de fontes alternativas. Se a primeira URL falhar (404, 403...),
 * tenta a proxima; se todas falharem, mostra um bloco neutro no mesmo tamanho.
 *
 * `image` aceita uma string ou um array de URLs.
 */
function SmartImage({ image, alt = "", style, width, height, className }) {
    const sources = (Array.isArray(image) ? image : [image]).filter(Boolean);
    const [index, setIndex] = useState(0);

    // reinicia quando a lista de fontes muda (ex.: paginacao)
    const key = sources.join("|");
    useEffect(() => {
        setIndex(0);
    }, [key]);

    if (index >= sources.length) {
        return (
            <div
                role="img"
                aria-label={alt || "Imagem indisponível"}
                className={className}
                style={{
                    width,
                    height,
                    background: "#EAECF0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6B6B6B",
                    fontFamily: "Raleway",
                    fontSize: "12px",
                    boxSizing: "border-box",
                    flexShrink: 0,
                    ...style,
                }}
            >
                Sem imagem
            </div>
        );
    }

    return (
        <img
            src={sources[index]}
            alt={alt}
            width={width}
            height={height}
            className={className}
            style={style}
            loading="lazy"
            onError={() => setIndex((i) => i + 1)}
        />
    );
}

export default SmartImage;
